import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Trans } from "react-i18next";
import { FaExclamationTriangle } from "react-icons/fa";

const SeatWarningModal = ({
  seatWarning,
  onClose,
  onConfirm,
  isUpdatingSeats,
  isUploading,
  t,
}) => {
  const available =
    (seatWarning?.reservedSeats || 0) - (seatWarning?.currentStudents || 0);
  const totalAfter =
    (seatWarning?.currentStudents || 0) + (seatWarning?.csvRows || 0);
  const exceedsVehicle =
    seatWarning?.vehicleSeats > 0 && totalAfter > seatWarning.vehicleSeats;
  const isLoading = isUpdatingSeats || isUploading;

  return (
    <Modal show={!!seatWarning} onHide={onClose} centered backdrop="static">
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title
          className="d-flex align-items-center gap-2"
          style={{ fontSize: 17, fontWeight: 600 }}
        >
          <FaExclamationTriangle style={{ color: "#f59e0b", fontSize: 18 }} />
          {t("errors.reserved_seats")} {t("errors.exceeded")}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ paddingTop: 12 }}>
        {/* Stat cards */}
        <div className="d-flex gap-2 mb-3">
          <div style={statCard("#f0fdf4", "#16a34a")}>
            <div style={statNum("#16a34a")}>
              {seatWarning?.reservedSeats ?? 0}
            </div>
            <div style={statLabel}>{t("errors.reserved_seats")}</div>
          </div>
          <div style={statCard("#fefce8", "#ca8a04")}>
            <div style={statNum("#ca8a04")}>
              {seatWarning?.currentStudents ?? 0}
            </div>
            <div style={statLabel}>{t("assigned")}</div>
          </div>
          <div style={statCard("#eff6ff", "#2563eb")}>
            <div style={statNum("#2563eb")}>{seatWarning?.csvRows ?? 0}</div>
            <div style={statLabel}>CSV {t("students")}</div>
          </div>
          <div
            style={statCard(
              available > 0 ? "#f0fdf4" : "#fef2f2",
              available > 0 ? "#16a34a" : "#dc2626",
            )}
          >
            <div style={statNum(available > 0 ? "#16a34a" : "#dc2626")}>
              {available}
            </div>
            <div style={statLabel}>{t("available")}</div>
          </div>
        </div>

        {/* Info message */}
        <div
          style={{
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            borderRadius: 8,
            padding: "10px 14px",
            fontSize: 14,
            color: "#475569",
            lineHeight: 1.7,
          }}
        >
          <Trans
            i18nKey="seat_warning"
            values={{
              availableSeats: available,
              csvRows: seatWarning?.csvRows || 0,
              totalAfter,
            }}
            components={{ strong: <strong style={{ color: "#1e293b" }} /> }}
          />
        </div>

        {/* Vehicle capacity warning */}
        {exceedsVehicle && (
          <div
            className="d-flex align-items-start gap-2 mt-2"
            style={{
              background: "#fef2f2",
              border: "1px solid #fecaca",
              borderRadius: 8,
              padding: "10px 14px",
              fontSize: 13,
              color: "#b91c1c",
            }}
          >
            <FaExclamationTriangle style={{ marginTop: 2, flexShrink: 0 }} />
            <Trans
              i18nKey="capacity_exceeded"
              values={{ vehicleSeats: seatWarning?.vehicleSeats || 0 }}
              components={{ strong: <strong /> }}
            />
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button
          variant="primary"
          size="sm"
          disabled={isLoading || exceedsVehicle}
          onClick={onConfirm}
        >
          {isLoading ? (
            <>
              <div className="spinner-border" role="status">
                <span className="sr-only p-0"></span>
              </div>
            </>
          ) : (
            t("increase_seats_upload")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const statCard = (bg, border) => ({
  flex: 1,
  background: bg,
  border: `1px solid ${border}22`,
  borderRadius: 8,
  padding: "10px 8px",
  textAlign: "center",
});
const statNum = (color) => ({
  fontSize: 26,
  fontWeight: 700,
  color,
  lineHeight: 1,
});
const statLabel = { fontSize: 13, color: "#64748b", marginTop: 4 };

export default SeatWarningModal;
